import Image from "../images/about-me.svg";

export default function AboutMe() {
  return (
    <div id="section2" className="about-me">
      <div className="about-image">
        <img src={Image} alt="" />
      </div>
      <div className="about-text">
        <h2>About Me</h2>
        <p id="one">Hi, This is ug.</p>
        <p id="two">
          An Future Entrepreneur, Tech lover and Developer. I’m passionate about
          doing new things in tech world. I like to work in team, and complete
          future goals with them.
        </p>
        <p id="three">
          "it takes two flints to make a fire." - Louisa May Alcott
        </p>

        <div className="about-button">
          <button>Download cv</button>
        </div>
      </div>
    </div>
  );
}
